"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IRdfStoreIndex.js.map